import { render, staticRenderFns } from "./PlatformConfig.vue?vue&type=template&id=4986fc08&scoped=true"
import script from "./PlatformConfig.vue?vue&type=script&lang=js"
export * from "./PlatformConfig.vue?vue&type=script&lang=js"
import style0 from "./PlatformConfig.vue?vue&type=style&index=0&id=4986fc08&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4986fc08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4986fc08')) {
      api.createRecord('4986fc08', component.options)
    } else {
      api.reload('4986fc08', component.options)
    }
    module.hot.accept("./PlatformConfig.vue?vue&type=template&id=4986fc08&scoped=true", function () {
      api.rerender('4986fc08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wechatOpenPlatform/components/PlatformConfig.vue"
export default component.exports